export default __webpack_public_path__ + "static/media/100_19586.e6d13dd7.jpg";